export default {
    path: '/billforinstallment',
    meta: {
        title: '账单分期',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/billlist`),
}


// WEBPACK FOOTER //
// ./src/views/BillForInstallment/router.js